export enum Roles {
  SUPER_ADMIN = 1,
  MANAGEMENT_SYSTEM = 2,
  OPERATOR_BO = 3,
  TECHNICIAN = 4,
}

export const RoleNames = {
  [Roles.SUPER_ADMIN]: 'SUPERADMIN',
  [Roles.MANAGEMENT_SYSTEM]: 'MANAGEMENT SYSTEM',
  [Roles.OPERATOR_BO]: 'OPERATOR BO',
  [Roles.TECHNICIAN]: 'TECHNICIAN',
};
